import CompanyApi from '../../services/CompanyData';
import {mutation} from './mutations';
import cfFilter from '../../utils/criticalFactors';
import flatSignalData from '../../utils/signals';
import {setAnalystData} from 'store/global/actions';

const handleError = (err) => {
    console.log('Error in company action : ', err);
};

export const setActiveRic = (ric) => (dispatch) => {
    dispatch(mutation.setActiveRic(ric));
};

export const getCompanySignals = (payload) => async (dispatch) => {
    try {
        const res = await CompanyApi.getCompanySignals(payload);
        // The response is grouped by signalId keys
        // Flatening the array
        const flatArray = flatSignalData(res);
        flatArray.sort((a, b) => (a.date > b.date ? -1 : 1)); // Sort the array in decreasing order of dates
        dispatch(mutation.setCompanySignals(flatArray));
    } catch (e) {
        handleError(e);
    }
};

export const getShareData = (id, type, ric) => async (dispatch) => {
    try {
        const res = await CompanyApi.getSharePrice(id, type, ric.ric);
        let activeRicValue = res[0] || '';
        let activeRic = res[0] ? res[0].ric : '';
        if (res[1]?.selected) {
            activeRicValue = res[1];
            activeRic = res[1].ric;
        }
        res.forEach(function (value) {
            if (value.ric === ric) {
                dispatch(mutation.setActiveRic(ric));
                dispatch(mutation.setActiveRicValue(value));
                dispatch(mutation.setCompanySharePrice(res));
            } else {
                dispatch(mutation.setActiveRic(activeRic));
                dispatch(mutation.setActiveRicValue(activeRicValue));
                dispatch(mutation.setCompanySharePrice(res));
            }
        });
    } catch (e) {
        handleError(e);
    }
};

export const getFinancialData = (payload) => async (dispatch) => {
    try {
        let res = await CompanyApi.getFinancialData(payload);
        // res = res.filter(
        //     ({financialFieldDetail: f}) => Array.isArray(f) && f.length > 0,
        // );
        let arr = [];
        Object.entries(res).forEach((item) => {
            arr.push({financialFieldDetail: item[1], title: item[0]});
        });
        dispatch(mutation.setFinancialData(arr));
        return arr;
    } catch (e) {
        handleError(e);
    }
};
export const getCriticalFactors = (id, type) => async (dispatch) => {
    if (type === 'Industry' || type === 'Country') {
        type += 'Template';
    }
    try {
        let rest = await CompanyApi.getEntityUiInfo(id, type);
        const cfArray = await CompanyApi.getCriticalFactorsNew(id, type, true);
        // Remove the factors with enabled value = 0
        const info = await dispatch(setAnalystData(rest));
        dispatch(mutation.setCriticalFactors(cfArray));
        dispatch(mutation.setCompanyAnalystData(info));

        // Filter into creditFactor/equityFactor
        dispatch(mutation.setFilteredCriticalFactors(cfFilter(cfArray)));
    } catch (e) {
        handleError(e);
    }
};

export const clearCompanyData = (payload) => async (dispatch) => {
    try {
        dispatch(mutation.setCompanyAnalystData({}));
        dispatch(mutation.setCompanySharePrice({}));
    } catch (e) {
        handleError(e);
    }
};
export const getStockConsensusData = (payload) => async (dispatch) => {
    try {
        const res = await CompanyApi.getStockConsensus(payload);
        dispatch(mutation.setStockConsensus(res));
    } catch (e) {
        handleError(e);
    }
};
export const getShareRatioData = (id, payload) => async (dispatch) => {
    try {
        const res = await CompanyApi.getShareRatioData(id, payload);
        dispatch(mutation.setShareRatio(res));
        return res;
    } catch (e) {
        handleError(e);
        return e;
    }
};
export const getRatioInfo = (payload) => async (dispatch) => {
    try {
        const res = await CompanyApi.getRatioInfo(payload);
        return res;
    } catch (err) {
        handleError(err);
        return err;
    }
};
export const getCompleteViewSummary = (payload) => async (dispatch) => {
    try {
        const res = await CompanyApi.getCompleteViewSummary(payload);
        dispatch(mutation.set360Data(res));
    } catch (e) {
        handleError(e);
        return e;
    }
};
export const getEPSspecificData = (payload) => async (dispatch) => {
    try {
        const res = await CompanyApi.getEpsRatioData(payload);
        dispatch(mutation.setEPSData(res));
    } catch (e) {
        handleError(e);
        return e;
    }
};
export const getSpecificCompanySignals = (payload) => async (dispatch) => {
    try {
        const res = await CompanyApi.getSpecificCompanySignals(payload);
        const flatSignals = flatSignalData(res);
        dispatch(mutation.setSpecificCompanySignals(flatSignals));
    } catch (e) {
        handleError(e);
        return e;
    }
};
export const getImpactData = (payload) => async (dispatch) => {
    try {
        const res = await CompanyApi.getImpactAnalysisData(payload);
        dispatch(mutation.setImpactData(res));
        return res;
    } catch (e) {
        handleError(e);
        return e;
    }
};
export const getNetworkData = (payload) => async (dispatch) => {
    const signalMap = {};
    function getSignalId(signal) {
        let arr = signal?.split('|');
        if (arr && arr.length) {
            signalMap[arr[0]] = arr[1];
        }
        return arr ? arr[0] : signal;
    }
    function getCFRes(list) {
        for (let key in list) {
            if (typeof list[key] !== 'number') {
                if (list[key]?.signals) {
                    cfRes = cfRes.concat(list[key].signals);
                } else {
                    getCFRes(list[key]);
                }
            }
        }
    }
    try {
        var result = await CompanyApi.getNetworkData(payload);
        let CF = result.criticalFactors;
        let companyId = payload.companyId;
        // result.criticalFactors = Object.keys(CF)?.reduce((acc,item)=>{
        //   for(let key in CF[item]){
        //     if(acc[key] && acc[key]['signals'] && CF[item][key]['signals']){
        //       acc[key]['signals']= new Set([...acc[key]['signals'],...CF[item][key]['signals']])
        //       acc[key]['signals']=[...acc[key]['signals']]
        //     }
        //     else{
        //       acc[key]=CF[item][key]
        //     }
        //   }
        //   return acc
        // },{})
        var cfRes = [];
        getCFRes(CF);
        cfRes = [...new Set(cfRes)];
        var res = result.graph;
        res.forEach((item, index) => {
            let endNode = item.endNode;
            let startNode = item.startNode;

            // adding signals to nodes
            item.endNode.signals = result?.signals?.[endNode.id]?.signals.map(
                (item) => getSignalId(item),
            );
            item.endNode.signalCount = result?.signals?.[endNode.id]?.count;
            item.startNode.signals = result?.signals?.[
                startNode.id
            ]?.signals.map((item) => getSignalId(item));
            item.startNode.signalCount = result?.signals?.[startNode.id]?.count;

            // adding critical factors to nodes
            // item.endNode.criticalFactors= result?.criticalFactors?.[endNode.id]?.signals.map(item=> getSignalId(item))
            // item.endNode.criticalFactCount= result?.criticalFactors?.[endNode.id]?.count
            // item.startNode.criticalFactors= result?.criticalFactors?.[startNode.id]?.signals.map(item=> getSignalId(item))
            // item.startNode.criticalFactCount= result?.criticalFactors?.[startNode.id]?.count
            if (endNode.id === companyId) {
                item.endNode.criticalFactors = cfRes.map((item) =>
                    getSignalId(item),
                );
            }
            if (startNode.id === companyId) {
                item.startNode.criticalFactors = cfRes.map((item) =>
                    getSignalId(item),
                );
            }

            // adding critical factors to nodes
            item.endNode.riskSignals = result?.riskSignals?.[
                endNode.id
            ]?.signals.map((item) => getSignalId(item));
            item.endNode.riskSignalsCount =
                result?.riskSignals?.[endNode.id]?.count;
            item.startNode.riskSignals = result?.riskSignals?.[
                startNode.id
            ]?.signals.map((item) => getSignalId(item));
            item.startNode.riskSignalsCount =
                result?.riskSignals?.[startNode.id]?.count;
        });
        dispatch(mutation.setNetworkData(res));
        dispatch(mutation.setSignalMap(signalMap));
        return res;
    } catch (e) {
        handleError(e);
        return e;
    }
};
export const getNetworkEntitySignals = async (payload) => {
    try {
        const res = await CompanyApi.networkGraphEntitySignals(payload);
        return res;
    } catch (e) {
        handleError(e);
        return e;
    }
};

export const setCompanyList = (payload) => async (dispatch) => {
    try {
        dispatch(mutation.setCompanyList(payload));
    } catch (e) {
        handleError(e);
        return e;
    }
};

export const showChatBot = () => (dispatch) => {
    try {
        dispatch(mutation.showChatBot());
    } catch (e) {
        handleError(e);
    }
};

export const showChatNotification = (payload) => (dispatch) => {
    try {
        dispatch(mutation.showChatNotification(payload));
    } catch (e) {
        handleError(e);
    }
};

export const checkAnalystStatus = (payload) => (dispatch) => {
    try {
        dispatch(mutation.checkAnalystStatus(payload));
    } catch (e) {
        handleError(e);
    }
};

export const resetCompanyGraphs = () => async (dispatch) => {
    dispatch(mutation.resetEpsData());
    dispatch(mutation.resetStockConcensusData());
    dispatch(mutation.resetShareRatioData());
    dispatch(mutation.resetFinancialData());
};
